import pkg from '../../../package.json'

export const LANGUAGES = [
  { label: 'English', languageCode: 'en' },
  { label: 'German', languageCode: 'de' },
  { label: 'Spanish', languageCode: 'es' },
  { label: 'French', languageCode: 'fr' },
  { label: 'Portuguese', languageCode: 'pt' },
  { label: 'Russian', languageCode: 'ru' }
]

/* ==========================================================================
  HTTP Method Types
========================================================================== */
export const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

export const DEFAULT_GAME_NAME = {
  pingoo: 1,
  hubert: 2,
  gemx: 3,
  wire: 4
}

export const MENU_SETTING_ITEM = {
  gameInfo: 'gameInfo',
  howToPlay: 'howToPlay',
  gameRule: 'gameRule',
  betHistory: 'betHistory',
  leaderboard: 'leaderboard',
  gameLimits: 'gameLimits',
  changeMode: 'changeMode'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
export const TOKEN = 'authToken'
export const LANGUAGE = 'operator_language'

/* ==========================================================================
  All the navigation route Paths
========================================================================== */

export const ROUTE_PATHS = {
  // ----single routes------------
  game: `${pkg?.homepage}launch`,
  replay: `${pkg?.homepage}replay`,
  error: '/error'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER = {
  BUTTON: 'button',
  CONTENT: 'content',
  TABLE_CELL: 'tableCell'
}

/* ==========================================================================
  Loader Types
========================================================================== */
export const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  Game Ids
========================================================================== */
export const DEFAULT_GAME_ID = {
  PINGOO_GAME: 1,
  MULTI_CRASH: 2,
  GEMX_GAME: 3,
  WIRE_GAME: 4,
  CRASH: 5
}

/* ==========================================================================
  Extra Constants Variables
========================================================================== */
export const PAGINATION_LIMIT = 20
export const MIN_WITHDRAW_AMOUNT = 0.003
export const WITHDRAW_FEES = 0.000006
export const DEFAULT_PAGE_CALLS = 10
export const DEFAULT_TOP_BET_TYPE_LIMIT = 20
export const DEFAULT_MY_BETS_LIMIT = 20
export const DEFAULT_PRECISION_MONEY = 2
export const DEFAULT_AUTO_BET_COUNTER = 3
export const DEFAULT_BET_AMOUNT_SC = 1
export const DEFAULT_BET_AMOUNT_GC = 2500
export const TAB_SELECTION = Object.freeze({
  placed: Symbol('placed'),
  previous: Symbol('previous')
})
export const MIN_PAYOUT = {
  CRASH: 1.1
}

export const APPEND_TYPES = {
  ROUND_STOPPED: 'ROUND_STOPPED',
  ESCAPE: 'ESCAPE'
}

export const DEFAULT_LIVE_STATS = { profit: 0, wins: 0, wagered: 0, losses: 0 }

/* ==========================================================================
  Game Result
========================================================================== */
export const BET_RESULT = {
  WON: 'won',
  LOST: 'lost',
  CANCELLED: 'cancelled'
}

/* ==========================================================================
  Wallet emit types
========================================================================== */
export const WALLET_EMIT_TYPES = {
  CREDIT: 'credit',
  DEBIT: 'debit',
  RESOLVE: 'resolve',
  DEFAULT: 'default'
}

export const CRASH_BET_LISTING_TYPE_TABS = {
  ALL_BETS: 'ALL_BETS',
  MY_BETS: 'MY_BETS',
  TOP_BETS: 'TOP_BETS'
}

export const DEFAULT_INCREASE_BY_PERCENTAGE = 5

export const CURRENCIES = {

  // real game currency
  USD: { isFiat: true, precision: 2, symbol: '$', label: 'US Dollar', value: 'USD' },
  EUR: { isFiat: true, precision: 2, symbol: '€', label: 'Euro', value: 'EUR' },
  AMD: { isFiat: true, precision: 2, symbol: '֏', label: 'Armenian Dram', value: 'AMD' },
  ARS: { isFiat: true, precision: 2, symbol: '$', label: 'Argentine Peso', value: 'ARS' },
  AUD: { isFiat: true, precision: 2, symbol: 'A$', label: 'Australian Dollar', value: 'AUD' },
  AZN: { isFiat: true, precision: 2, symbol: '₼', label: 'Azerbaijanian Manat', value: 'AZN' },
  BAM: { isFiat: true, precision: 2, symbol: 'BAM', label: 'Bosnia and Herzegovina Convertible Mark', value: 'BAM' },
  BDT: { isFiat: true, precision: 2, symbol: '৳', label: 'Bangladeshi Taka', value: 'BDT' },
  BGN: { isFiat: true, precision: 2, symbol: 'лв', label: 'Bulgarian Lev', value: 'BGN' },
  BRL: { isFiat: true, precision: 2, symbol: 'R$', label: 'Brazilian Real', value: 'BRL' },
  BYN: { isFiat: true, precision: 2, symbol: 'BYN', label: 'Belarusian Ruble', value: 'BYN' },
  CAD: { isFiat: true, precision: 2, symbol: 'CAD', label: 'Canadian Dollar', value: 'CAD' },
  CHF: { isFiat: true, precision: 2, symbol: 'CHF', label: 'Swiss Franc', value: 'CHF' },
  CLP: { isFiat: true, precision: 2, symbol: 'CLP', label: 'Chilean Peso', value: 'CLP' },
  CNY: { isFiat: true, precision: 2, symbol: 'CNY', label: 'Chinese Yuan Renminbi', value: 'CNY' },
  COP: { isFiat: true, precision: 2, symbol: 'COP', label: 'Colombian Peso', value: 'COP' },
  CRC: { isFiat: true, precision: 2, symbol: 'CRC', label: 'Costa Rican Colon', value: 'CRC' },
  CZK: { isFiat: true, precision: 2, symbol: 'CZK', label: 'Czech Koruna', value: 'CZK' },
  DKK: { isFiat: true, precision: 2, symbol: 'DKK', label: 'Danish Krone', value: 'DKK' },
  FUN: { isFiat: true, precision: 2, symbol: 'FUN', label: 'Demo Currency', value: 'FUN' },
  GBP: { isFiat: true, precision: 2, symbol: 'GBP', label: 'Pound Sterling', value: 'GBP' },
  GEL: { isFiat: true, precision: 2, symbol: 'GEL', label: 'Georgian Lari', value: 'GEL' },
  GHS: { isFiat: true, precision: 2, symbol: 'GHS', label: 'Ghana Cedi', value: 'GHS' },
  HUF: { isFiat: true, precision: 2, symbol: 'HUF', label: 'Hungarian Forint', value: 'HUF' },
  IDR: { isFiat: true, precision: 2, symbol: 'IDR', label: 'Indonesian Rupiah', value: 'IDR' },
  INR: { isFiat: true, precision: 2, symbol: 'INR', label: 'Indian Rupee', value: 'INR' },
  JPY: { isFiat: true, precision: 0, symbol: 'JPY', label: 'Japanese Yen', value: 'JPY' },
  KRW: { isFiat: true, precision: 0, symbol: 'KRW', label: 'South Korean Won', value: 'KRW' },
  KZT: { isFiat: true, precision: 2, symbol: 'KZT', label: 'Kazakhstani Tenge', value: 'KZT' },
  MDL: { isFiat: true, precision: 2, symbol: 'MDL', label: 'Moldovan Leu', value: 'MDL' },
  MGA: { isFiat: true, precision: 2, symbol: 'MGA', label: 'Malagasy Ariary', value: 'MGA' },
  MMK: { isFiat: true, precision: 2, symbol: 'MMK', label: 'Myanmar Kyat', value: 'MMK' },
  MNT: { isFiat: true, precision: 2, symbol: 'MNT', label: 'Mongolian Tögrög', value: 'MNT' },
  MXN: { isFiat: true, precision: 2, symbol: 'MXN', label: 'Mexican Peso', value: 'MXN' },
  MYR: { isFiat: true, precision: 2, symbol: 'MYR', label: 'Malaysian Ringgit', value: 'MYR' },
  NOK: { isFiat: true, precision: 2, symbol: 'NOK', label: 'Norwegian Krone', value: 'NOK' },
  NZD: { isFiat: true, precision: 2, symbol: 'NZD', label: 'New Zealand Dollar', value: 'NZD' },
  PEN: { isFiat: true, precision: 2, symbol: 'PEN', label: 'Peruvian Sol', value: 'PEN' },
  PKR: { isFiat: true, precision: 2, symbol: 'PKR', label: 'Pakistan Rupee', value: 'PKR' },
  PLN: { isFiat: true, precision: 2, symbol: 'PLN', label: 'Polish Zloty', value: 'PLN' },
  RON: { isFiat: true, precision: 2, symbol: 'lei', label: 'Romanian Leu', value: 'RON' },
  RSD: { isFiat: true, precision: 2, symbol: 'дин', label: 'Serbian Dinar', value: 'RSD' },
  RUB: { isFiat: true, precision: 2, symbol: '₽', label: 'Russian Ruble', value: 'RUB' },
  SEK: { isFiat: true, precision: 2, symbol: 'SEK', label: 'Swedish Krona', value: 'SEK' },
  SGD: { isFiat: true, precision: 2, symbol: 'S$', label: 'Singapore Dollar', value: 'SGD' },
  THB: { isFiat: true, precision: 2, symbol: '฿', label: 'Thai Baht', value: 'THB' },
  TND: { isFiat: true, precision: 3, symbol: 'د.ت', label: 'Tunisian Dinar', value: 'TND' },
  TRY: { isFiat: true, precision: 2, symbol: '₺', label: 'Turkish Lira', value: 'TRY' },
  TZS: { isFiat: true, precision: 2, symbol: 'TZS', label: 'Tanzanian Shilling', value: 'TZS' },
  UAH: { isFiat: true, precision: 2, symbol: '₴', label: 'Ukrainian Hryvnia', value: 'UAH' },
  UYU: { isFiat: true, precision: 2, symbol: '$U', label: 'Peso Uruguayo', value: 'UYU' },
  UZS: { isFiat: true, precision: 2, symbol: 'UZS', label: 'Uzbekistani Sum', value: 'UZS' },
  VEF: { isFiat: true, precision: 2, symbol: 'VEF', label: 'Venezuelan Bolívar Fuerte', value: 'VEF' },
  VND: { isFiat: true, precision: 2, symbol: '₫', label: 'Vietnamese Dong', value: 'VND' },
  XAF: { isFiat: true, precision: 2, symbol: 'XAF', label: 'Central African CFA Franc', value: 'XAF' },
  XOF: { isFiat: true, precision: 2, symbol: 'XOF', label: 'West African CFA Franc', value: 'XOF' },
  ZAR: { isFiat: true, precision: 2, symbol: 'ZAR', label: 'South African Rand', value: 'ZAR' },
  ZMW: { isFiat: true, precision: 2, symbol: 'ZMW', label: 'Zambian Kwacha', value: 'ZMW' }
}
